module.exports = __webpack_public_path__ + "img/transformerRight.72f5e6f2.png";